module.exports = __webpack_public_path__ + "3201e48c053b90855ca4eee1b9ea9383.svg";